import StackViewport from '../StackViewport.js';
import VolumeViewport from '../VolumeViewport.js';
import ViewportType from '../../enums/ViewportType.js';
import ViewportTypes, { registerViewportTypesConstant, } from '../../enums/ViewportTypes.js';
import LegacyVolumeViewport3D from '../VolumeViewport3D.js';
import VideoViewport from '../VideoViewport.js';
import WSIViewport from '../WSIViewport.js';
import LegacyECGViewport from '../ECGViewport.js';
import ECGViewport from '../GenericViewport/ECG/ECGViewport.js';
import PlanarViewport from '../GenericViewport/Planar/PlanarViewport.js';
import PlanarViewportLegacyAdapter from '../GenericViewport/Planar/PlanarViewportLegacyAdapter.js';
import NextVideoViewport from '../GenericViewport/Video/VideoViewport.js';
import VideoViewportLegacyAdapter from '../GenericViewport/Video/VideoViewportLegacyAdapter.js';
import VolumeViewport3D from '../GenericViewport/Volume3D/viewport3D.js';
import VolumeViewport3DLegacyAdapter from '../GenericViewport/Volume3D/VolumeViewport3DLegacyAdapter.js';
import NextWSIViewport from '../GenericViewport/WSI/WSIViewport.js';
import WSIViewportLegacyAdapter from '../GenericViewport/WSI/WSIViewportLegacyAdapter.js';
import ECGViewportLegacyAdapter from '../GenericViewport/ECG/ECGViewportLegacyAdapter.js';
const viewportConstructors = new Map();
const viewportTypeToViewportClass = {};
const resolvers = [];
const registeredViewportTypes = new Set();
let hasRegisteredCoreViewportTypes = false;
function registerCoreViewportTypes() {
    if (hasRegisteredCoreViewportTypes) {
        return;
    }
    hasRegisteredCoreViewportTypes = true;
    registerViewportType({
        type: ViewportType.ORTHOGRAPHIC,
        ViewportClass: VolumeViewport,
    });
    registerViewportType({
        type: ViewportType.PERSPECTIVE,
        ViewportClass: VolumeViewport,
    });
    registerViewportType({
        type: ViewportType.STACK,
        ViewportClass: StackViewport,
    });
    registerViewportType({
        type: ViewportType.VOLUME_3D,
        ViewportClass: LegacyVolumeViewport3D,
    });
    registerViewportType({
        type: ViewportType.WHOLE_SLIDE,
        ViewportClass: WSIViewport,
    });
    registerViewportType({
        type: ViewportType.ECG,
        ViewportClass: LegacyECGViewport,
    });
    registerViewportType({
        type: ViewportType.VIDEO,
        ViewportClass: VideoViewport,
    });
    registerViewportType({
        type: ViewportType.VOLUME_3D_NEXT,
        ViewportClass: VolumeViewport3D,
        resolveClass: ({ type, requestedType }) => type === ViewportType.VOLUME_3D_NEXT &&
            requestedType === ViewportType.VOLUME_3D
            ? VolumeViewport3DLegacyAdapter
            : undefined,
    });
    registerViewportType({
        type: ViewportType.PLANAR_NEXT,
        ViewportClass: PlanarViewport,
        resolveClass: ({ type, requestedType }) => type === ViewportType.PLANAR_NEXT &&
            (requestedType === ViewportType.STACK ||
                requestedType === ViewportType.ORTHOGRAPHIC)
            ? PlanarViewportLegacyAdapter
            : undefined,
    });
    registerViewportType({
        type: ViewportType.VIDEO_NEXT,
        ViewportClass: NextVideoViewport,
        resolveClass: ({ type, requestedType }) => type === ViewportType.VIDEO_NEXT && requestedType === ViewportType.VIDEO
            ? VideoViewportLegacyAdapter
            : undefined,
    });
    registerViewportType({
        type: ViewportType.ECG_NEXT,
        ViewportClass: ECGViewport,
        resolveClass: ({ type, requestedType }) => type === ViewportType.ECG_NEXT && requestedType === ViewportType.ECG
            ? ECGViewportLegacyAdapter
            : undefined,
    });
    registerViewportType({
        type: ViewportType.WHOLE_SLIDE_NEXT,
        ViewportClass: NextWSIViewport,
        resolveClass: ({ type, requestedType }) => type === ViewportType.WHOLE_SLIDE_NEXT &&
            requestedType === ViewportType.WHOLE_SLIDE
            ? WSIViewportLegacyAdapter
            : undefined,
    });
}
export function registerViewportType({ type, name, ViewportClass, resolveClass, }) {
    if (viewportConstructors.has(type)) {
        throw new Error(`Viewport type "${type}" is already registered`);
    }
    if (name && Object.prototype.hasOwnProperty.call(ViewportTypes, name)) {
        throw new Error(`Viewport type constant "${name}" already exists`);
    }
    viewportConstructors.set(type, ViewportClass);
    viewportTypeToViewportClass[type] = ViewportClass;
    registeredViewportTypes.add(type);
    if (name) {
        registerViewportTypesConstant(name, type);
    }
    if (resolveClass) {
        resolvers.push(resolveClass);
    }
}
export function isRegisteredViewportType(type) {
    registerCoreViewportTypes();
    return registeredViewportTypes.has(type);
}
export default viewportTypeToViewportClass;
export function getViewportClassForInput(input) {
    registerCoreViewportTypes();
    for (const resolveClass of resolvers) {
        const resolved = resolveClass(input);
        if (resolved) {
            return resolved;
        }
    }
    const viewportClass = viewportConstructors.get(input.type);
    if (!viewportClass) {
        throw new Error(`Unknown viewport type: ${input.type}`);
    }
    return viewportClass;
}
